<template>
    <div>
      <el-dialog :visible.sync="addUpdateRecordDialogVisible" title="添加升级记录" @close="feedBack" v-if="addUpdateRecordDialogVisible">
        <el-form label-width="100px" :model="AddUpdateRecord.params" :ref="AddUpdateRecord.params" :rules="rulesOfAddUpdateRecord">
          <el-form-item label="警报点编号" prop="alarmPointId">
            <!--<el-input v-model="AddUpdateRecord.params.alarmPointId"></el-input>-->
            <el-select placeholder="警报点" class="handle_input" v-model="AddUpdateRecord.params.alarmPointId" @click="getAlarmPointList"
                       filterable clearable style="width: 100%">
              <el-option
                v-for="item in alarmPointList.result.pointNameList"
                :label="item.pointName" :value="item._id"></el-option>
            </el-select>
          </el-form-item>
          <AlarmPointInfo :alarm-point-id="AddUpdateRecord.params.alarmPointId"></AlarmPointInfo>
          <el-form-item label="升级时间" prop="updateTime" style="margin-top: 30px;">
            <el-date-picker type="datetime" v-model="AddUpdateRecord.params.updateTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
<!--          <el-form-item label="升级人" prop="updaterId">-->
<!--            &lt;!&ndash;<el-input v-model="AddUpdateRecord.params.updaterId"></el-input>&ndash;&gt;-->
<!--            <el-select placeholder="升级人" class="handle_input" v-model="AddUpdateRecord.params.updaterId" @click.native="getUserList"-->
<!--                       filterable clearable style="width: 100%">-->
<!--              <el-option-->
<!--                v-for="item in userList.result.userList"-->
<!--                :label="item.name"-->
<!--                :value="item._id"></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <el-form-item label="升级内容" prop="updateContent">
            <el-input type="textarea" :rows="2" v-model="AddUpdateRecord.params.updateContent"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="feedBack">取 消</el-button>
          <el-button type="primary" @click="addUpdateRecord">确定添加</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  import AlarmPointInfo from '../../../components/AlarmPointInfo'
  export default {
    name: 'AddUpdateRecord',
    components: { AlarmPointInfo },
    props: ['addUpdateRecordDialogVisible'],
    data(){
      return {
        rulesOfAddUpdateRecord:{
          alarmPointId: [{required: true, message:'警报点编号不能为空', trigger: 'change'}],
          updateTime: [{required: true, message:'升级时间不能为空', trigger: 'change'}],
          // updaterId:[{required: true, message:'升级人不能为空', trigger: 'change'}],
          updateContent:[{required: true, message:'升级内容不能为空', trigger: 'change'}],
        },
        // 添加升级记录
        AddUpdateRecord:{
          "version": 1,
          "method": "update.AddUpdateRecord",
          "params": {
            "alarmPointId": "",
            "updateTime": "",
            "updaterId":"",
            "updateContent":"",
          },
          "token": "#",
          "id": 0
        },
        // 获取警报点列表
        GetAlarmPointList:{
          "version": 1,
          "method": "alarmpoint.GetPointNameList",
          "params": {
            // "pointName":null,
            // "alarmPointType":null,
            // "areaId":null
          },
          "token": "#",
          "id": 0
        },
        // 警报点列表
        alarmPointList:{
          "version": 1,
          "result":{
            "alarmPointList": [
              {
                "alarmPointId":  "",
                "pointName": "",
                "alarmPointType": "",
                "longitude": "",
                "latitude": "",
                "alarmRadius":"",
                "areaId":"",
                "installAt":"",
                "remark":""
              },
            ]
          },
          "id": 0
        },
        // 获取用户列表
        GetUserList:{
          "version": 1,
          "method": "user.GetUserList",
          "params": {
            "username":"",
            "name":"",
            "role":""
          },
          "token": "",
          "id": 0
        },
        // 账户列表
        userList:{
          "version": 1,
          "result":{
            "userList":[],
          },
          "id": 0
        },
      }
    },
    methods: {
      // 获取警报点列表
      getAlarmPointList(){
        for (let val in this.GetAlarmPointList.params){
          if(this.GetAlarmPointList.params[val] === ""){
            this.GetAlarmPointList.params[val] = null;
          }
        }
        // if(this.GetAlarmPointList.params.areaId !== null){
        //   this.GetAlarmPointList.params.areaId = this.GetAlarmPointList.params.areaId[this.GetAlarmPointList.params.areaId.length-1];
        // }
        this.GetAlarmPointList.token = this.$store.state.token;
        console.log('获取警报点列表请求');
        console.log(this.GetAlarmPointList);
        this.$axios.post(this.$mainUrl, this.GetAlarmPointList).then(res=>{
          if(res.data.hasOwnProperty('result')){
            console.log('获取警报点列表请求得到响应');
            console.log(res.data);
            this.alarmPointList = res.data;
          }
        })
      },
      // 获取用户列表
      getUserList(){
        for(let key in this.GetUserList.params){
          if(this.GetUserList.params[key] === ""){
            this.GetUserList.params[key] = null;
          }
        }
        this.GetUserList.token = this.$store.state.token;
        console.log('获取用户列表请求');
        console.log(this.GetUserList);
        this.$axios.post(this.$mainUrl, this.GetUserList).then(res =>{
          console.log('获取用户列表请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.userList = res.data;
          }else{
            this.$message({
              type:'error',
              message:'获取用户列表失败，' + res.data.error.message
            })
          }
        })
      },
      feedBack(){
        this.cleanArguments(this.AddUpdateRecord.params);
        this.resetValidate(this.AddUpdateRecord.params);
        this.addUpdateRecordDialogVisible = false;
        this.$emit('feedBack', this.addUpdateRecordDialogVisible);
      },
      addUpdateRecord(){
        this.AddUpdateRecord.token = this.$store.state.token;
        this.AddUpdateRecord.params.updaterId = localStorage.getItem('userId');
        console.log('添加升级记录请求');
        console.log(this.AddUpdateRecord);
        this.$axios.post(this.$mainUrl, this.AddUpdateRecord).then(res =>{
          console.log('添加升级记录请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.$message({
              type: 'success',
              message: '添加成功'
            })
            this.feedBack()
          }
          else{
            this.$message({
              type: 'error',
              message:'添加失败，' + res.data.message
            })
          }
        })
      }
    },
    mounted () {
      this.getAlarmPointList()
    }
  }
</script>

<style scoped>

</style>
